module.exports = __webpack_public_path__ + "img/38t.f36c000f.jpg";